import React, { useState, useEffect } from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useTranslation } from 'react-i18next';
import { deleteResource } from '../../../services/ResourcesService';

const DeleteResourceModal = ({ resourceName, resourceId, open, onClose, onDelete }) => {
  
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await deleteResource(resourceId);
      onDelete(resourceId);
      onClose();
    } catch (error) {
      console.error('Error deleting resource:', error);
      alert(t('error_deleting_resource'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle><span className="roboto-regular">{t('delete_resource')}</span></DialogTitle>
      <DialogContent>
        <Typography><span className="roboto-light">{t('delete_resource_confirmation', { resourceName })}</span></Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <LoadingButton loading={loading} onClick={handleDelete} variant="contained">
          {t('delete')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteResourceModal;
